import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { CSSProperties, useContext, useState } from 'react';
import { ArtContainer } from '../components/art-container.component';
import { AuctionPrice } from '../components/auction-price.component';
import { Countdown } from '../components/countdown.component';
import { Header } from '../components/header.component';
import { PlaceBidModal } from '../components/place-bid-modal.component';
import { BidModalModel } from '../model/bid-modal.model';
import { AppContext } from '../stores/app.store';
import { useModal } from 'nfty-common/lib/hooks/bootstrap.hooks';

const leftStyle: CSSProperties = {
    overflow: 'hidden',
    flex: '0 0 58%',
    borderRight: '2px solid #707070'
};

const rightStyle: CSSProperties = {
    flex: '0 0 42%'
};

export const HomePage = observer(() => {
    const { auctionStore } = useContext(AppContext);

    const [bidModel] = useState(new BidModalModel())
    const { ref, modal } = useModal<HTMLDivElement>();

    function toggle() {
        if (modal) {
            bidModel.reset();
            bidModel.setPriceWhenOpened(auctionStore.auctionData?.salePrice);
            bidModel.setEndTime(auctionStore.auctionData?.endDate);
            modal.toggle();
        }
    }

    return (
        <div className="h-100 w-100 d-flex">
            <div style={leftStyle}>
                <ArtContainer />
            </div>
            <div style={rightStyle} className="d-flex flex-column">
                <Header />
                <div className="text-115 w-100 px-4 m-auto d-flex bg-darker">
                    {auctionStore?.auctionData?.endDate &&
                        <div className="mx-auto text-end">
                            <Countdown className="text-300 bg-darker text-avenir-ul h1 mb-0" endTime={auctionStore.auctionData.endDate} />
                            <div style={{ marginTop: '-8px' }} className="ps-3 text-avenir-re text-themed h5 bg-darker">
                                <FontAwesomeIcon transform={{ y: -2, x: 2 }} size="sm" icon={['fas', 'stopwatch']} />
                                <span className="ms-2">TIME REMAINING</span>
                            </div>
                        </div>
                    }
                </div>
                <div className="border-top border-secondary ps-4 pe-2 d-flex justify-content-between align-items-center">
                    <AuctionPrice className="bg-darker" value={auctionStore.auctionData?.salePrice} />
                    <button className="btn btn-outline-light bg-darker" onClick={toggle}>
                        <FontAwesomeIcon icon="coins" />
                        <span className="ms-2">Place Bid</span>
                    </button>
                </div>
            </div>
            <div ref={ref} className="modal fade" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <PlaceBidModal model={bidModel} currentBid={auctionStore.auctionData?.salePrice} closeToggle={toggle} />
                </div>
            </div>
        </div>
    );
});